/* eslint-disable */

import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgDivider = ({ width, height }) => {
    return (<Svg
        viewBox="0 0 1 101"
        height={height}
        width={width}
    >
        <Defs>
            <LinearGradient x1="-6540.19699%" y1="100%" x2="-6540.19698%" y2="0%" id="linearGradient-1">
                <Stop stopColor="#F3F3F3" offset="0"></Stop>
                <Stop stopColor="#000000" offset="1"></Stop>
            </LinearGradient>
        </Defs>
        <G id="Bar-with-caption-box" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-602.000000, -53.000000)" strokeLinecap="square">
            <Path d="M602.5,54 L602.5,153" id="Line-Copy-139" stroke="url(#linearGradient-1)" strokeWidth="0.5"></Path>
        </G>

    </Svg>)
}

